import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { _set_channel, set_cid, set_cpid } from "../store/actions/login_actions";
import { BaseChannel } from "../base/env";

export const useFastCheckoutParams = () => {
  const dispatch = useDispatch();
  const Login = useSelector((state) => state.Login);
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const urlProductId = query.get("productId");
  const urlVariantId = query.get("variantId");
  const urlQty = Number(query.get("qty") || 1);
  const urlChannel = query.get("channel");
  const urlCid = query.get("cid");
  const urlCpid = query.get("cpid");

  const [productId, setProductId] = useState(urlProductId);
  const [variantId, setVariantId] = useState(urlVariantId);
  const [quantity, setQuantity] = useState(urlQty);
  const [channel, setChannel] = useState(urlChannel || Login.channel || BaseChannel);
  const [cid, setCid] = useState(urlCid || Login.cid || "");
  const [cpid, setCpid] = useState(urlCpid || Login.cpid || "gmall");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // 3️⃣ restore pending FastCheckout از localStorage
    const pendingStr = localStorage.getItem("pendingFastChackout");
    const pending = pendingStr ? JSON.parse(pendingStr) : null;

    const finalChannel = urlChannel || (pending?.channel ?? channel);
    const finalCid = urlCid || (pending?.cid ?? cid);
    const finalCpid = urlCpid || (pending?.cpid ?? cpid);

    const finalProductId = urlProductId || (pending?.productId ?? productId);
    const finalVariantId = urlVariantId || (pending?.variantId ?? variantId);
    const finalQuantity = urlQty || (pending?.quantity ?? quantity);

    dispatch(_set_channel(finalChannel));
    dispatch(set_cid(finalCid));
    dispatch(set_cpid(finalCpid));

    setChannel(finalChannel);
    setCid(finalCid);
    setCpid(finalCpid);
    setProductId(finalProductId);
    setVariantId(finalVariantId);
    setQuantity(finalQuantity);

    setReady(true); // trigger auto checkout

    if (pendingStr) localStorage.removeItem("pendingFastChackout");
  }, [dispatch, urlChannel, urlCid, urlCpid, urlProductId, urlVariantId, urlQty]);

  return {
    productId,
    variantId,
    quantity,
    channel,
    cid,
    cpid,
    ready,
  };
};
